<template>
  <div class="m2">
    <!-- 悬浮展示按钮    -->
    <div
      class="menu-f position-fixed cursor"
      :class="[!menuFlag ? 'openMenuBtn' : '']"
      :style="transformStyle"
    >
      <div class="menu-btn" @click="showMenu"></div>
    </div>
    <!-- 花边 -->
    <!-- <div
      class="title-282 title1-top position-absolute"
      :class="menuFlag ? 'open' : ''"
      :style="common.handleScale()"
    >
      <div class="title1 title-size"></div>
    </div>
    <div
      class="title-282 title2-bottom position-absolute"
      :class="menuFlag ? 'open' : ''"
      :style="common.handleScale()"
    >
      <div class="title2 title-size"></div>
    </div> -->

    <div
      class="share-btn position-absolute cursor"
      :class="menuFlag ? 'open' : ''"
      :style="transformStyle"
    >
      <!-- 黄色按钮 -->
      <div
        class="d-flex align-items-center justify-content-center cursor mb-24"
      >
        <div class="game-btn icon-size mr-12" @click="DC_page('dc')"></div>
        <div class="yt-btn icon-size mr-12" @click="youtube_page('yt')"></div>
        <div class="fb-btn icon-size mr-12" @click="FB_page('fb')"></div>
        <div class="twi-btn icon-size" @click="Twitter_page('twi')"></div>
      </div>
      <!-- apple, goole, onestore -->
      <div class="share-btn">
        <div
          class="cursor apple-btn icon-share-size mb-16"
          @click="GP_reg('as')"
        ></div>
        <div
          class="cursor goole-btn icon-share-size mb-16"
          @click="AS_reg('gp')"
        ></div>
      </div>
    </div>
    <!-- logl -->
    <div
      class="bg-282 position-absolute"
      :class="menuFlag ? 'open' : ''"
      :style="transformStyle"
    >
      <div class="logo"></div>
    </div>

    <swiper :options="swiperOption" ref="goodSwiper">
      <swiper-slide>
        <home
          ref="slider1"
          @handleChangeModel="handleChangeModel"
          @handleInvite="handleInvite"
        />
      </swiper-slide>
      <!-- <swiper-slide><rewards /></swiper-slide> -->
      <swiper-slide><news /></swiper-slide>
      <swiper-slide> <characters /> </swiper-slide>
      <swiper-slide> <prologue /></swiper-slide>
      <!-- 分页菜单  menuFlag ? 'open' : '',-->
      <div
        class="swiper-pagination swiper-pagination-home cursor"
        :class="[
          nextShow ? '' : 'swiperNoSwiping',
          menuFlag ? 'open' : '',
          pointEvent ? 'pointEvent' : '',
        ]"
        slot="pagination"
        :style="transformStyle"
      ></div>
    </swiper>
  </div>
</template>

<script>
import home from "./publicComponents/home";
import prologue from "./publicComponents/prologue";
import characters from "./publicComponents/characters";
// import rewards from "./publicComponents/rewards";
import news from "./publicComponents/news";
export default {
  name: "Home",
  components: {
    home,
    characters,
    prologue,
    // rewards,
    news,
  },
  data() {
    return {
      transformStyle: {}, //缩放
      //  screenHeight = $(window).height(),
      wFlag: false,
      pointEvent: false,
      menuFlag: true, // 默认不展示菜单，只展示按钮
      showMobileFlag: false,
      nextShow: true,
      swiperOption: {
        direction: "vertical",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // height: window.innerHeight, // 高度设置，占满设备高度
        mousewheel: true, //开启鼠标
        speed: 1100, //滚动速度
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        pagination: {
          el: ".swiper-pagination-home",
          touchRatio: 1, //解决滑动卡顿
          longSwipesRatio: 0.1,
          threshold: 10, //如果触摸距离小于该值滑块不会被拖动
          followFinger: false,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          clickable: true, // 允许点击小圆点跳转
          autoplayDisableOnInteraction: false,

          renderBullet: function (index, className) {
            switch (index) {
              case 0:
                name = "";
                break;
              case 1:
                name = "";
                break;
              case 2:
                name = "";
              case 3:
                name = "";
              default:
                name = "";
            }
            return (
              '<div class="' +
              className +
              " " +
              className +
              [index] +
              '"><i>' +
              name +
              "</i></div>"
            );
          },
        },
        on: {
          resize: function () {
            setTimeout(() => {
              this.update();
            }, 500); //延时器很重要，不加可能会出错
          },
        },
      },
    };
  },
  created() {},
  updated() {},
  mounted() {
    this.handleTransformStyle();
    window.addEventListener("resize", () => {
      this.handleTransformStyle();
    });
  },
  watch: {},
  computed: {},
  methods: {
    handleChangeModel(item) {
      this.menuFlag = !item;
    },
    // 缩放
    handleTransformStyle() {
      this.transformStyle = this.common.handleScale();
    },
    // 点击跳转到第二页
    handleInvite() {
      this.$refs.goodSwiper.swiper.slideTo(0, 300, true); //切换到第一个slide，速度为1秒
    },
    // 用来控制注册页，在注册的时候，禁止拖动等
    handleClose(val) {
      this.nextShow = val;
      this.swiperOption.mousewheel = val;
      this.swiperOption.noSwiping = false;

      this.$refs.goodSwiper.swiper.destroy(); //先销毁
      this.swiperOption.initialSlide = 1;
      this.$refs.goodSwiper.mountInstance(); //后在加载
    },
    handleEVent(val) {
      this.nextShow = val;
      this.swiperOption.mousewheel = val;
      this.swiperOption.noSwiping = true;

      this.$refs.goodSwiper.swiper.destroy(); //先销毁
      this.swiperOption.initialSlide = 1;
      this.$refs.goodSwiper.mountInstance(); //后在加载
    },
    // 菜单显示
    showMenu() {
      this.menuFlag = !this.menuFlag;
    },
    // 跳转到twi
    Twitter_page(val) {
      this.common.goShare(val);
    },
    // 跳转到咖啡
    DC_page(val) {
      this.common.goShare(val);
    },
    // 跳转到youtube
    youtube_page(val) {
      this.common.goShare(val);
    },
    // 跳转到FB
    FB_page(val) {
      this.common.goShare(val);
    },
    // 跳转到goole
    GP_reg(val) {
      this.common.goShare(val);
    },
    // AS_reg
    AS_reg(val) {
      this.common.goShare(val);
    },

    // 角色详情展示的时候，菜单隐藏
    handlePointEvent(val) {
      this.pointEvent = val;
    },
  },
};
</script>
<style lang="scss" >
.m2 {
  height: 100%;
  background: rgba(0, 0, 0, 0.74);
  .title1-top {
    top: 148px;
  }
  .title2-bottom {
    bottom: 20vw;
  }
  .title-282 {
    width: 282px;
    left: -282px;
    z-index: 999;
    transition: all 0.5s;
    div {
      margin: 0 auto;
    }
  }
  // 悬浮展示按钮
  .bg-282 {
    width: 282px;
    top: 23px;
    left: -282px;
    z-index: 999;
    transition: all 0.5s;
    div {
      margin: 0 auto;
    }
  }

  .menu-bg {
    width: 282px;
  }
  // 悬浮按钮
  .menu-f {
    width: 342px;
    z-index: 999;
    top: 5%;
    left: 0;
    height: 60px;
    min-height: 60px;
    transition: all 0.5s;
    transform-origin: left top;
  }
  .menu-btn {
    background: url("../assets/img/menu-btn.png") no-repeat center;
    background-size: 100% 100%;
    width: 60px;
    height: 60px;
    min-height: 60px;

    float: right;
  }
  .openMenuBtn {
    width: 60px !important;

    transform-origin: left;
  }
  // 分享按钮
  .share-btn {
    width: 282px;
    bottom: 12px;
    z-index: 999;
    left: -282px;
    transition: all 0.5s;
    transform-origin: center bottom;
    .share-btn {
      width: 282px;
      div {
        margin: 12px auto;
      }
    }
    .icon-size {
      width: 32px;
      height: 32px;
    }
    .icon-share-size {
      width: 124px;
      height: 36px;
    }
    .twi-btn {
      background: url("../assets/img/icon/t.png") no-repeat center;
      background-size: 100% 100%;
    }
    .game-btn {
      background: url("../assets/img/icon/game.png") no-repeat center;
      background-size: 100% 100%;
    }
    .yt-btn {
      background: url("../assets/img/icon/inline.png") no-repeat center;
      background-size: 100% 100%;
    }
    .fb-btn {
      background: url("../assets/img/icon/fb.png") no-repeat center;
      background-size: 100% 100%;
    }
    .apple-btn {
      background: url("../assets/img/home/apple-btn.png") no-repeat center;
      background-size: 100% 100%;
    }
    .goole-btn {
      background: url("../assets/img/home/goole-btn.png") no-repeat center;
      background-size: 100% 100%;
    }
    .onestore-btn {
      background: url("../assets/img/home/onestore-btn.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
  // logo
  .logo {
    width: 227px;
    height: 66px;

    background: url("../assets/img/home/logo.png") no-repeat center;
    background-size: 100% 100%;
  }

  // 点击后的动画展示位置
  .open-btn {
    left: 282px;
  }

  .open {
    // transform: translateX(0) !important;
    left: 0 !important;
    transform-origin: left;
  }

  // 轮播
  .swiper-container {
    width: 100%;
    height: 100%;

    // 分页
    .pointEvent {
      pointer-events: none;
    }
    .swiper-pagination-home {
      left: -282px;
      top: 0;
      width: 282px;
      min-height: 1080px;
      height: 10000px;
      background-color: rgba($color: #000000, $alpha: 0.74);
      background-size: 100% 100%;
      transition: all 0.5s;
      transform-origin: left top;
      .swiper-pagination-bullet-active {
        background: transparent;
      }
      .my-bullet {
        display: flex;
        justify-content: center;
        i {
          display: block;
          margin-left: -2px;
        }
      }
      .my-bullet0 i {
        display: block;
        width: 51px;
        height: 12px;
        margin-top: 245px;
        background: url("../assets/img/home/menu1.png") center top;
        background-size: 100% 100%;
      }
      // 隐藏 rewards  ，所以把后面的索引值-1
      // .my-bullet1 i {
      //   display: block;
      //   width: 86px;
      //   height: 12px;
      //   margin-top: 45px;
      //   background: url("../assets/img/home/menu2.png") center top;
      //   background-size: 100% 100%;
      // }
      .my-bullet1 i {
        display: block;
        width: 49px;
        height: 12px;
        margin-top: 55px;
        background: url("../assets/img/home/menu3.png") center top;
        background-size: 100% 100%;
      }
      .my-bullet2 i {
        display: block;
        width: 115px;
        height: 12px;
        margin-top: 55px;

        background: url("../assets/img/home/menu4.png") center top;
        background-size: 100% 100%;
      }
      .my-bullet3 i {
        display: block;
        width: 91px;
        height: 12px;
        margin-top: 55px;

        background: url("../assets/img/home/menu5.png") center top;
        background-size: 100% 100%;
      }
      .my-bullet0.swiper-pagination-bullet-active i {
        background: url("../assets/img/home/menu1-active.png") center top;
        background-size: 100% 100%;
        width: 144px;
        height: 43px;
      }
      // 隐藏 rewards  ，所以把后面的索引值-1
      // .my-bullet1.swiper-pagination-bullet-active i {
      //   background: url("../assets/img/home/menu2-active.png") center top;
      //   background-size: 100% 100%;
      //   width: 144px;
      //   height: 43px;
      // }
      .my-bullet1.swiper-pagination-bullet-active i {
        background: url("../assets/img/home/menu3-active.png") center top;
        background-size: 100% 100%;
        width: 144px;
        height: 43px;
      }
      .my-bullet2.swiper-pagination-bullet-active i {
        background: url("../assets/img/home/menu4-active.png") center top;
        background-size: 100% 100%;
        width: 144px;
        height: 43px;
      }
      .my-bullet3.swiper-pagination-bullet-active i {
        background: url("../assets/img/home/menu5-active.png") center top;
        background-size: 100% 100%;
        width: 144px;
        height: 43px;
      }
    }
  }
}

// 提示横屏展示
.mobile-h {
  img {
    display: block;
  }
  .box {
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .close-btn {
    width: 240px;
    height: 102px;
    display: block;
    margin: 46px auto;
  }
}

@keyframes loop-scene {
  0% {
    background-position: 0;
  }
  to {
    background-position: -2580px;
  }
}
// 花边
.title-size {
  width: 96px;
  height: 17px;
  // transform: translateX(-282px);
  // left: -282px;
  // transition: all 0.5s;
}
.title1 {
  z-index: 2;
  background: url("../assets/img/home/title1.png") top center;
  background-size: 100% 100%;
}
.title2 {
  z-index: 2;
  background: url("../assets/img/home/title2.png") top center;
  background-size: 100% 100%;
  // bottom: 29vh;
  // left: 92px;
}
</style>


// WEBPACK FOOTER //
// src/components/MainIndex.vue